export const INQUIRY_CATEGORY_MAP = {
    1: '문구 변경',
    2: '도입문의',
    3: '결제',
    4: '서비스',
    5: '회원',
    6: '기타',
};